export default "__VITE_ASSET__CZBjiYGk__"